const siteStatuses = {
  id: "siteStatuses",
  label: "Site Statuses",
  endpoint: "site_statuses",
  columnConfig: [
    {
      field: "name",
      headerName: "Site Status",
      width: 250,
      description: "Site Status",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default siteStatuses;
